import { render } from "./SubPermissionComp.vue?vue&type=template&id=388532b4&scoped=true"
import script from "./SubPermissionComp.vue?vue&type=script&lang=js"
export * from "./SubPermissionComp.vue?vue&type=script&lang=js"

import "./SubPermissionComp.vue?vue&type=style&index=0&id=388532b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388532b4"]])

export default __exports__